// extracted by mini-css-extract-plugin
module.exports = {"loaderxs":"loader-xs_loaderxs__1AIHE","loadxs":"loader-xs_loadxs__3uTBp"};